import { formatInTimeZone } from 'date-fns-tz';

const DEFAULT_TIMEZONE = 'America/Sao_Paulo';

export function formatDate(
  date: string | Date,
  timezone = DEFAULT_TIMEZONE,
): string {
  return formatInTimeZone(date, timezone, 'dd/MM/yyyy HH:mm');
}

export function toFilterFormat(date: string | Date): string {
  return formatInTimeZone(date, 'UTC', 'yyyy-MM-dd HH:mm');
}
